/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React, { useState } from "react";
import styles from "./Filter.module.css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Today from "@material-ui/icons/Today";
import HelpOutline from "@material-ui/icons/HelpOutline";
import { fetchAllProperty } from "./../../../store/actions";
import { useDispatch, useSelector, batch } from "react-redux";
import { toast } from "react-toastify";
import { constant } from "./../../../shared/constants/constants";
import Clear from "@material-ui/icons/Clear";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import { ChasingDots } from "styled-spinkit";
import FilterWrapper from "./FilterWrapper";
import {
  updateShowWorkOrderUserInfoCheckBox,
  updateShowInfoWindowCheckBox,
  updateJobTypeFilterValue,
} from "./../../../store/actions";
import Tooltip from "./../../../Tooltip/Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    "&$checked": {
      color: "#8fa225",
    },
  },
  checked: {},
  loadingCont: {
    position: "absolute",
    left: 0,
    right: 0,
    backgroundColor: "#00000047",
    zIndex: 1000,
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  formCtrlRoot: {
    marginRight: "4px",
  },
  formCtrl: {
    fontSize: "14px",
  },
}));

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#8fa225",
      contrastText: "#fff",
    },
  },
});

const Filter = () => {
  const dispatch = useDispatch();

  const [allowInactive, setAllowInactive] = useState(false);
  const [serviceDate, setServiceDate] = useState(null);
  const isLoading = useSelector((state) => state.ui.isLoading);

  // handle any changes happen in checkbox
  const handleCheckboxChange = (event) => {

    // set checkbox status in state
    setAllowInactive(event.target.checked);

    // fetch properties with allowInactive = true/false according to checkbox status
    dispatch(
      fetchAllProperty(event.target.checked, serviceDate, { currentPage: 1 })
    );

    // show toast
    toast.info(constant.FETCHING_PROPERTIES);
  };

  // fetch selected date properties
  const serviceDateHandler = (date) => {
    setServiceDate(date);
    batch(() => {
      dispatch(updateShowWorkOrderUserInfoCheckBox(false));
      dispatch(updateShowInfoWindowCheckBox(false));
      dispatch(updateJobTypeFilterValue(""));
      dispatch(fetchAllProperty(allowInactive, date, { currentPage: 1 }));
    });
    toast.info(constant.FETCHING_PROPERTIES);
  };

  // clear selected dates and fetch properties
  const onDateClear = (e) => {
    e.stopPropagation();
    setServiceDate(null);
    batch(() => {
      dispatch(updateShowWorkOrderUserInfoCheckBox(false));
      dispatch(updateShowInfoWindowCheckBox(false));
      dispatch(updateJobTypeFilterValue(""));
      dispatch(fetchAllProperty(allowInactive, null, { currentPage: 1 }));
    });

    toast.info(constant.FETCHING_PROPERTIES);
  };

  const classes = useStyles();

  return (
    <div>
      <div className={styles.FilterCont}>
        {isLoading && (
          <div className={classes.loadingCont}>
            <ChasingDots color="#F28E1A" size={35} />
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "12px", color: "grey" }}>
            <Today />
          </span>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <div className={styles.DateCont}>
              <div className={styles.DateCrd}>
                <ThemeProvider theme={theme}>
                  <DatePicker
                    style={{ width: "125px" }}
                    autoOk
                    // disabled
                    variant="inline"
                    format="DD MMM"
                    value={serviceDate}
                    onChange={serviceDateHandler}
                    animateYearScrolling
                    emptyLabel={constant.SERVICE_DATE}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: serviceDate ? (
                        <InputAdornment position="end">
                          <Tooltip arrow title={constant.CLEAR}>
                            <IconButton onClick={onDateClear}>
                              <Clear />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                </ThemeProvider>
              </div>
            </div>
          </MuiPickersUtilsProvider>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel
            classes={{ label: classes.formCtrl, root: classes.formCtrlRoot }}
            control={
              <Checkbox
                checked={allowInactive}
                onChange={handleCheckboxChange}
                name="inactive"
                classes={{
                  root: classes.root,
                  checked: classes.checked,
                }}
              />
            }
            label={constant.INCLUDE_INACTIVE}
          />
          <Tooltip
            style={{ color: "grey" }}
            title={constant.I_ICON_HOVER_GEOFENCE}
            arrow>
            <HelpOutline />
          </Tooltip>
        </div>
      </div>

      {serviceDate && <FilterWrapper />}
    </div>
  );
};

export default React.memo(Filter);
